














import Vue from 'vue';
import Component from 'vue-class-component';
import {Emit, Prop} from 'vue-property-decorator';

@Component({})
export default class EditButton extends Vue {
  @Prop({required: false, default: false}) loading!: boolean;
  @Prop({required: false, default: false}) disabled!: boolean;
  @Prop({required: true}) label!: string;
  @Prop({required: false, default: 'fa-edit'}) icon!: string;

  @Emit()
  onClick() {
    return;
  }
}
